import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionService } from '@app/shared/services/session.service';
import { Router } from '@angular/router';
import { MenuService } from '@app/shared/services/menu.service';
import { environment } from '@env/environment';
import { AlertService } from '@app/shared/services/alert.service';
import { RestApiService } from '@app/shared/services/rest-api.service';

@Component({
  selector: 'app-recoveryPassword',
  templateUrl: './recoveryPassword.component.html',
  styleUrls: ['./recoveryPassword.component.scss']
})
export class RecoveryPasswordComponent implements OnInit {

  public passwordupdateForm;
  public release: string = environment.release;
  public token: string = "";
  public _keyStr: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  public success: boolean = false;

  constructor(
    private titleService: TitleService,
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private menu: MenuService,
    private router: Router,
    private alertService: AlertService,
    private api: RestApiService
  ) {
    if (this.sessionService.isSigned === true) {
      // this.router.navigateByUrl(`/`);
    }
  }

  ngOnInit() {
    this.titleService.setTitle(`Récupération de mot de passe`);
    this.menu.setMenuState('Recovery password', '', '');
    this.passwordupdateForm = this.formBuilder.group({
      newpassword: '',
      confirmpassword: ''
    });

    // get query URL
    const query = this.router.parseUrl(this.router.url).queryParams;
    this.token = query?.pkey;
  }

  async changepassword(credentials) {

    if (credentials.newpassword == "") return this.alertService.error('Veuillez saisir un mot de passe');
    if (credentials.newpassword !== credentials.confirmpassword) return this.alertService.error('Les mots de passe ne correspondent pas');

    //check if password assez fort
    if (!credentials.newpassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{5,})/)) {
      return this.alertService.error('Votre mot de passe doit contenir au moins 5 caractères dont 1 majuscule, 1 minuscule et 1 chiffre.');
    }

    this.success = await this.sessionService.recoveryPassword(this.token, this.encode(credentials.newpassword));
  }

  encode(input: string) {
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;

    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
    }

    return output;
  }
}
